import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getServiceWithoutActRequests, addServiceWithoutActRequest, editServiceWithoutActRequest, deleteServiceWithoutActRequest, getServiceWithoutActRequestByKey } from "../../redux/actions/serviceWithoutActRequestActions";
import CreateServiceWithoutActRequest from "./Popups/CreateServiceWithoutActRequest";
import ServiceWithoutActRequestDetails from "./Popups/ServiceWithoutActRequestDetails";
import EditServiceWithoutActRequest from "./Popups/EditServiceWithoutActRequest";
import RemoveServiceWithoutActRequest from "./Popups/RemoveServiceWithoutActRequest";

function createData(id, number, createdAt, contractRequest, state, filial) {
    return {id, number, createdAt, contractRequest, state, filial};
}

let rows = [
    createData(1, "abc", "12.03.2021 00:00", null, null, null),
];
const ServiceWithoutActRequestList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("serviceWithoutActRequestList.tableItem.id")},
        {text: t("serviceWithoutActRequestList.tableItem.number")},
        {text: t("serviceWithoutActRequestList.tableItem.createdAt")},
        {text: t("serviceWithoutActRequestList.tableItem.contractRequest")},
        {text: t("serviceWithoutActRequestList.tableItem.state")},
        {text: t("serviceWithoutActRequestList.tableItem.filial")},
        {text: t("serviceWithoutActRequestList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addServiceWithoutActRequest(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getServiceWithoutActRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getServiceWithoutActRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editServiceWithoutActRequest(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getServiceWithoutActRequestByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteServiceWithoutActRequest(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.serviceWithoutActRequest);
    if (!localData && state.serviceWithoutActRequests)
    {
        rows = state.serviceWithoutActRequests;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getServiceWithoutActRequests(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("serviceWithoutActRequestList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("serviceWithoutActRequestList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    number: _.number,
                    createdAt: _.createdAt,
                    contractRequest: _.contractRequest?.number,
                    state: _.state?.name,
                    filial: _.filial?.name,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateServiceWithoutActRequest action={'create'} title={t("serviceWithoutActRequestList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <ServiceWithoutActRequestDetails action={'details'} title={t("serviceWithoutActRequestList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditServiceWithoutActRequest action={'edit'} title={t("serviceWithoutActRequestList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveServiceWithoutActRequest action={'remove'} title={t("serviceWithoutActRequestList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default ServiceWithoutActRequestList;
